'use client';

import { Typography } from '@repo/ui/Typography';
import { useEffect, useRef } from 'react';
import { useFunnelStepId } from '@/features/funnel/state/funnel/Context/hooks';

export const FUNNEL_STEP_TITLE_ID = 'funnel-step-title';

type Props = {
  children: React.ReactNode;
};

export function StepTitle({ children }: Props) {
  const ref = useRef<HTMLElement>(null);
  const stepId = useFunnelStepId();

  useEffect(() => {
    ref.current?.focus({ preventScroll: true });
  }, [stepId]);

  return (
    <Typography
      ref={ref}
      as="h1"
      id={FUNNEL_STEP_TITLE_ID}
      tabIndex={-1}
      variant="heading.h1"
      css={{
        lineHeight: '[1.3]',
        color: 'neutral.darkest',
        fontWeight: 'bold',
        fontFamily: 'gotham',
        outline: 'none',
        fontSize: { base: '22px', sm: '32px' },
      }}
    >
      {children}
    </Typography>
  );
}
